import svc from 'svc';
import svcQuery from 'svc/query';


export const cookie = {
	put: (name, value, expires) => {
		// Bakes a new cookie. If no expires date is provided, the cookie will become a session cookie.
		var newCookie = name + '=' + encodeURI(value) + ';';

		if (expires) {
			expires = new Date(expires);
			newCookie += 'expires=' + expires.toUTCString() + ';';
		}
		document.cookie = newCookie;
	},
	
	putObject: (name, value, expires) => {
		var encoded = btoa(JSON.stringify(value));
		cookie.put(name, encoded, expires);
	},
	
	getObject: (name) => {
		var cookieVal = cookie.get(name);
		if(cookieVal) {
			return JSON.parse(atob(cookieVal));
		} else {
			return false;
		}
	},

	get: (name) => {
		// Searches document.cookie for a cookie by a given name and returns the value if one is found.
		var temp = document.cookie.split(/;\s*/);
		for(var i = 0, l = temp.length; i < l; i++) {
			var foundName = temp[i].split('=')[0];
			if (foundName === name) {
				return temp[i].split('=')[1];
			}
		}
		return false;
	},

	remove: (name) => {
		// Deletes a given cookie by setting an expiration date in the past
		if (cookie.get(name)) {
			var date = new Date(1985, 3, 22);
			cookie.put(name, '', date);
		}
	},

	exists: (name) => {
		return cookie.get(name) !== false;
	}
}

export const stringTestRegexp = (value, testString) => {
	const re = new RegExp("^.*"+ testString +".*","gi"); 
	return re.test(value);
}

export const parseResponse = (data, isSingle) => {
	/*
		Returns an Array of Object or single object having the following format
		@isSingle = false -> [{column: rowValue}]
		@isSingle = true -> { column: rowValue }
		@data is Automat's response from Query
	*/
	const noData = typeof data === 'undefined' || typeof data !== 'object' || data === '';
	if (noData) {
		console.error('parseResponse() missing or bad parameter 1: data; this should be a query response as it comes from the websocket');
		return false;
	}

	const returnSingle = isSingle === true;

	const columns = findColumns(data);
	const rows = findRows(data);

	if(rows === false  || columns === false) {
		console.error('Rows or columns could not be found, please verify websocket response and findColumns(), findRows() methods');
		return false;
	}

	return createResult();

	function createResult() {
		let result = null;
		if (returnSingle === true) {
			result = createRowObj(columns, rows[0])
		} else {
			result = [];
			for (let i = 0; i < rows.length; i++) {
				result.push(createRowObj(columns, rows[i]));
			}
		}
		return result;
	}

	function createRowObj(columns, row) {
		let obj = {};
		for (let i = 0; i < columns.length; i++) {
			let type = columns[i].Type;
			let value = row[i];
			if((type.match(/int/i)) && row[i] !== null) {
				value = parseInt(row[i], 10)
			}
			obj[columns[i].Name] = value;
		}
		return obj;
	}
}

export const findColumns = (data) => {
	try {
		return data.Data.Result.Result.Columns;
	} catch(error) {
		return false;
	}
} 

export const findRows = (data) => {
	try {
		return data.Data.Result.Result.Rows;
	} catch(error) {
		return false;
	}
}

export const objectToXML = function(obj, root) {
	// http://goessner.net/download/prj/jsonxml/
	// ... but I made it readable and just better overall
	return createXMLHeader() + createInteralXML() + createXMLFooter();

	function createXMLHeader() {
		return '<?xml version="1.0" encoding="utf-8"?>\n<' + root + '>\n';
	}

	function createInteralXML() {
		var internalXML = '';
		Object.keys(obj).forEach(processElements);
		return internalXML;

		function processElements(element) {
			internalXML += toXML(obj[element], element, '\t');

			function toXML(value, key, depth) {
				var xml = '';
				if (Array.isArray(value) === true) {
					processArray(value);
				} else if (value !== null && typeof value === 'object') {
					if(Object.keys(value).length === 0) {
						return xml;
					}
					processObject(value);
				} else {
					processString(value);
				}
				
				return xml;
		
				function processArray(arr) {
					arr.forEach(processArrayElement);

					function processArrayElement(element) {
						xml += toXML(element, key, depth);
					}
				}
		
				function processObject(obj) {
					var hasNonAttributeChild = false;
					createOpeningBracket();
					createCustomAttributes();
					createClosingBracket();
					createNonAttributeChild();
					createClosingElement();
		
					function createOpeningBracket() {
						xml += depth + '<' + key;
					}
		
					function createCustomAttributes() {
						Object.keys(obj).forEach(handleAttributeChildren);   
		
						function handleAttributeChildren(element) {
							if (element.charAt(0) === '@') {
								addAttributeToElement();
							} else {
								hasNonAttributeChild = true;
							}
							function addAttributeToElement() {
								xml += ' ' + element.substr(1) + '="' + htmlSpecialChars(obj[element]).toString() + '"';
							}
						}
					}
		
					function createClosingBracket() {
						xml += (hasNonAttributeChild) ? '>\n' : '/>\n';
					}
		
					function createNonAttributeChild() {
						function handleElementTypes(element) {
							if (element === '#text') {
								xml += htmlSpecialChars(obj[element]);
							} else if (element === '#cdata') {
								xml += '<![CDATA[' + obj[element] + ']]>';
							} else if (element.charAt(0) !== '@'){
								xml += toXML(obj[element], element, depth + '\t');
							}
						}

						if (hasNonAttributeChild) {
							Object.keys(obj).forEach(handleElementTypes);
						}
					}
		
					function createClosingElement() {
						var lastChar = xml.charAt(xml.length-1);
						var isClosingParent = lastChar === '\n';
						xml += (isClosingParent ? depth : '');
						xml +='</' + key + '>\n';
					}
				}
		
				function processString(str) {
					xml += depth + '<' + key + '>' + htmlSpecialChars(str).toString() +  '</' + key + '>\n';
				}
		
				function htmlSpecialChars(unsafe) {
					if(typeof unsafe === 'undefined') {
						return '';
					}
					if(unsafe === null) {
						return '';
					}
					if (typeof unsafe === 'string') {
						//unsafe xml values &, <, >, "
						return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
					}
					return unsafe;
				}
			}
		}
	}

	function createXMLFooter() {
		return '</' + root + '>';
	}
}


let uniqueNumber = 0;

export const createUniqueNumber = function() {
	let date = Date.now();
	const hasBeenReturnedPreviously = date <= uniqueNumber; 
	uniqueNumber = date;
	if(hasBeenReturnedPreviously) {
		uniqueNumber += 1;
	} 
	return uniqueNumber.toString();
}

export const fieldProcessor = (parser, objectToParse) => {
	let fields = {};
	Object.keys(parser).forEach((attr) => {
		const fieldName = parser[attr];
		fields[fieldName] = objectToParse[attr];
	});
	return fields;
}

export const write = (baseObject) => {
	const xml = objectToXML(baseObject, 'Objects');

	return svc.send('passthrough', {
		Type: 'RepoFileImport',
		FileExtension: 'xml',
		Content: xml,
		Async: false
	}).then(function(result) {
		return result.payload;
	});
}

export const addHandler = (type, fn) => {
	return svc.addHandler(type, fn);
}

export const broadcast = (msg, type) => {
	const payload = {
		to: '*',
		msg,
		type
	}
	return svc.send('broadcast', payload);
}

export const retrieve = (query, params) => {
	return svcQuery(query, {Params: params});
}

export const retrieveAndReturnRowCol = (query, params) => {
	return new Promise((resolve) => {
		svcQuery(query, {Params: params}).then((res) => {
			const returnObj = {
				rows: findRows(res),
				columns: findColumns(res)
			}
			resolve(returnObj);
		});
	})
}

export const retrieveAndParse = (query, params) => {
	return new Promise((resolve) => {
		svcQuery(query, {Params: params}).then((res) => {
			resolve(res.parsed);
		});
	});
}

export const flattenArrayOfArrays = (arr) => {
	return arr.reduce((a, b) => a.concat(b), []);
};

export const makeRandomString = (length) => {
	// Creates a randomized alphanumeric string of the given length
	// Useful for creating generic but unique IDs, session keys, or whatever
	length = length || 20;
	let result = '', temp = '';
	while (result.length < length) {
		temp = Math.random().toString(36).slice(2);
		result += temp.slice(0, Math.min(temp.length, (length - result.length)));
	}
	return result.toUpperCase();
};

export const createUniqueIdForArray = (arr) => {
	return arr.map((obj) => {
		const requiresUniqueID = obj.uniqueID === null || !obj.hasOwnProperty('uniqueID');
		return requiresUniqueID ? Object.assign(obj, { uniqueID: createUniqueID(obj)}) : obj
	});
}

export const createUniqueID = (obj) => {
	return obj.subTypeKey + obj.type + obj.subType
}

export const usStatesArray = () => {
	return [
		{
			"name": "Alabama",
			"abbreviation": "AL"
		},
		{
			"name": "Alaska",
			"abbreviation": "AK"
		},
		{
			"name": "Arizona",
			"abbreviation": "AZ"
		},
		{
			"name": "Arkansas",
			"abbreviation": "AR"
		},
		{
			"name": "California",
			"abbreviation": "CA"
		},
		{
			"name": "Colorado",
			"abbreviation": "CO"
		},
		{
			"name": "Connecticut",
			"abbreviation": "CT"
		},
		{
			"name": "Delaware",
			"abbreviation": "DE"
		},
		{
			"name": "District Of Columbia",
			"abbreviation": "DC"
		},
		{
			"name": "Florida",
			"abbreviation": "FL"
		},
		{
			"name": "Georgia",
			"abbreviation": "GA"
		},
		{
			"name": "Hawaii",
			"abbreviation": "HI"
		},
		{
			"name": "Idaho",
			"abbreviation": "ID"
		},
		{
			"name": "Illinois",
			"abbreviation": "IL"
		},
		{
			"name": "Indiana",
			"abbreviation": "IN"
		},
		{
			"name": "Iowa",
			"abbreviation": "IA"
		},
		{
			"name": "Kansas",
			"abbreviation": "KS"
		},
		{
			"name": "Kentucky",
			"abbreviation": "KY"
		},
		{
			"name": "Louisiana",
			"abbreviation": "LA"
		},
		{
			"name": "Maine",
			"abbreviation": "ME"
		},
		{
			"name": "Maryland",
			"abbreviation": "MD"
		},
		{
			"name": "Massachusetts",
			"abbreviation": "MA"
		},
		{
			"name": "Michigan",
			"abbreviation": "MI"
		},
		{
			"name": "Minnesota",
			"abbreviation": "MN"
		},
		{
			"name": "Mississippi",
			"abbreviation": "MS"
		},
		{
			"name": "Missouri",
			"abbreviation": "MO"
		},
		{
			"name": "Montana",
			"abbreviation": "MT"
		},
		{
			"name": "Nebraska",
			"abbreviation": "NE"
		},
		{
			"name": "Nevada",
			"abbreviation": "NV"
		},
		{
			"name": "New Hampshire",
			"abbreviation": "NH"
		},
		{
			"name": "New Jersey",
			"abbreviation": "NJ"
		},
		{
			"name": "New Mexico",
			"abbreviation": "NM"
		},
		{
			"name": "New York",
			"abbreviation": "NY"
		},
		{
			"name": "North Carolina",
			"abbreviation": "NC"
		},
		{
			"name": "North Dakota",
			"abbreviation": "ND"
		},
		{
			"name": "Ohio",
			"abbreviation": "OH"
		},
		{
			"name": "Oklahoma",
			"abbreviation": "OK"
		},
		{
			"name": "Oregon",
			"abbreviation": "OR"
		},
		{
			"name": "Pennsylvania",
			"abbreviation": "PA"
		},
		{
			"name": "Rhode Island",
			"abbreviation": "RI"
		},
		{
			"name": "South Carolina",
			"abbreviation": "SC"
		},
		{
			"name": "South Dakota",
			"abbreviation": "SD"
		},
		{
			"name": "Tennessee",
			"abbreviation": "TN"
		},
		{
			"name": "Texas",
			"abbreviation": "TX"
		},
		{
			"name": "Utah",
			"abbreviation": "UT"
		},
		{
			"name": "Vermont",
			"abbreviation": "VT"
		},
		{
			"name": "Virgin Islands",
			"abbreviation": "VI"
		},
		{
			"name": "Virginia",
			"abbreviation": "VA"
		},
		{
			"name": "Washington",
			"abbreviation": "WA"
		},
		{
			"name": "West Virginia",
			"abbreviation": "WV"
		},
		{
			"name": "Wisconsin",
			"abbreviation": "WI"
		},
		{
			"name": "Wyoming",
			"abbreviation": "WY"
		}
	]
}

/**
 * @description Translate objects column to dictionary value if dictionary has value 
 * @param {object} objToTranslate object to be translated
 * @param {object} dictionary dictionary which has matching columns to objToTranslate
 * @returns {object} Translated object
 */
export const translateObjectByDictionary = (objToTranslate, dictionary) => {
	let translated = {};
	Object.keys(objToTranslate).forEach((column) => {
		if(dictionary.hasOwnProperty(column)) {
			translated[dictionary[column]] = objToTranslate[column]
		}
	});
	return translated;
}


// WEBPACK FOOTER //
// ./src/utilities/Utility.js